import { jsx as _jsx } from "react/jsx-runtime";
// File: src/routes/modulesRoutes.tsx
import React from "react";
// Lazy-load all module components
const CustomerFocusModule = React.lazy(() => import("../components/Iso9kprinciple/CustomerFocusModule"));
const LeadershipModule = React.lazy(() => import("../components/Iso9kprinciple/Leadership"));
const EngagementOfPeople = React.lazy(() => import("../components/Iso9kprinciple/EngagementOfPeople"));
const Improvement = React.lazy(() => import("../components/Iso9kprinciple/Improvement"));
const ProcessApproach = React.lazy(() => import("../components/Iso9kprinciple/ProcessApproach"));
const EvidenceBased = React.lazy(() => import("../components/Iso9kprinciple/EvidenceBased"));
const Relationship = React.lazy(() => import("../components/Iso9kprinciple/Relationship"));
// Add new modules here as your app grows
// const SomeNewModule = React.lazy(() => import("../components/Iso9kprinciple/SomeNewModule"));
/**
 * Array of module routes.
 * Each object defines a path and the lazy-loaded component to render.
 * Add new modules by adding new objects to this array.
 */
const modulesRoutes = [
    { path: "/customer-focus", element: _jsx(CustomerFocusModule, {}) },
    { path: "/leadership", element: _jsx(LeadershipModule, {}) },
    { path: "/engagement-of-people", element: _jsx(EngagementOfPeople, {}) },
    { path: "/improvement", element: _jsx(Improvement, {}) },
    { path: "/process-approach", element: _jsx(ProcessApproach, {}) },
    { path: "/evidence-based", element: _jsx(EvidenceBased, {}) },
    { path: "/relationship", element: _jsx(Relationship, {}) },
    // { path: "/some-new-module", element: <SomeNewModule /> },
];
export default modulesRoutes;
